/* eslint-disable no-magic-numbers */
// reworked from https://codesandbox.io/s/wheel-of-prize-forked-zikutr

import { angleAdjustment, outerRimSize, textMargin } from './constants';
import { contrastColor, fontFamily, primaryColor, rimColor, shadowColor } from './styles';

const PI2 = Math.PI * 2;

export const draw = (ctx, wheelCanvas, outerRimCanvas, state, settings) => {
	clear(ctx, settings);
	drawWheelFromBackgroundCanvas(ctx, wheelCanvas, state, settings);
	drawOuterRimFromBackgroundCanvas(ctx, outerRimCanvas, settings);
};

export const drawOuterRim = (ctx, settings) => {
	drawRim(ctx, settings);
	drawNeedle(ctx, settings);
};

const drawNeedle = (ctx, settings) => {
	const {
		center,
		radius
	} = settings;
	ctx.lineWidth = 1;
	
	const width = radius / 5;
	const height = radius / 6;
	const topAdjustment = 10;
	const needleBaseY = center - radius - topAdjustment;
	const needlePinY = center - radius + height - topAdjustment;

	const gradient = ctx.createRadialGradient(
		center,
		needlePinY,
		height * 2 / 3,
		center,
		needlePinY,
		height
	);

	// Add three color stops
	gradient.addColorStop(0, '#F8B800');
	gradient.addColorStop(1, '#FCE297');

	ctx.fillStyle = gradient;
	ctx.beginPath();
	ctx.moveTo(center + width / 2, needleBaseY);
	ctx.lineTo(center - width / 2, needleBaseY);
	ctx.lineTo(center, needlePinY);
	ctx.closePath();
	ctx.shadowColor = shadowColor;
	ctx.shadowBlur = 4;
	ctx.shadowOffsetX = 0;
	ctx.shadowOffsetY = 4;
	ctx.stroke();
	ctx.fill();
};

const drawSegment = (ctx, settings, key, lastAngle, angle) => {
	const {
		segments,
		center,
		radius,
	} = settings;

	const value = segments[key].name;
	const fontSize = segments[key].fontSize;
	angle -= angleAdjustment;
	lastAngle -= angleAdjustment;
	ctx.save();
	ctx.beginPath();
	ctx.moveTo(center, center);
	ctx.arc(center, center, radius, lastAngle, angle, false);
	ctx.lineTo(center, center);
	ctx.closePath();
	ctx.fillStyle = segments[key].color;
	ctx.fill();
	ctx.stroke();
	ctx.save();
	ctx.translate(center, center);
	ctx.rotate((lastAngle + angle) / 2);
	ctx.fillStyle = contrastColor;
	ctx.strokeStyle = primaryColor;
	ctx.lineWidth = 4;
	ctx.font = `bold ${fontSize}vmin ${fontFamily}`;
	ctx.textAlign = 'center';
	ctx.strokeText(value, radius / 2 + textMargin / 2, 0);

	ctx.fillText(value, radius / 2 + textMargin / 2, 0);
	ctx.restore();
};

const drawWheelFromBackgroundCanvas = (ctx, backgroundCanvas, state, settings) => {
	const { angle: angleCurrent } = state;
	const {
		center,
	} = settings;

	ctx.save();
	ctx.translate(center, center);
	ctx.rotate(angleCurrent);
	ctx.drawImage(backgroundCanvas,-center,-center);
	ctx.restore();
};

const drawOuterRimFromBackgroundCanvas = (ctx, backgroundCanvas, settings) => {
	const {
		center,
	} = settings;

	ctx.save();
	ctx.translate(center, center);
	ctx.drawImage(backgroundCanvas,-center,-center);
	ctx.restore();
};

export const drawWheel = (ctx, settings, angleCurrent = 0) => {
	const {
		segments,
	} = settings;
	let lastAngle = angleCurrent;

	const len = segments.length;
	ctx.lineWidth = 1;
	ctx.strokeStyle = primaryColor;
	ctx.textBaseline = 'middle';
	ctx.textAlign = 'center';
	for (let i = 1; i <= len; i++) {
		const angle = PI2 * (i / len) + angleCurrent;
		drawSegment(ctx, settings, i - 1, lastAngle, angle);
		lastAngle = angle;
	}
	
};

const drawRim = (ctx, settings) => {
	const {
		center,
		radius
	} = settings;
	ctx.save();
	ctx.beginPath();
	ctx.arc(center, center, radius - 5, 0, PI2, false);
	ctx.closePath();
	ctx.lineWidth = outerRimSize;
	ctx.strokeStyle = rimColor;
	ctx.shadowColor = shadowColor;
	ctx.shadowBlur = 4;
	ctx.shadowOffsetX = 4;
	ctx.shadowOffsetY = 4;
	ctx.stroke();
	ctx.restore();
};

const clear = (ctx, settings) => {
	const { center } = settings;
	ctx.clearRect(0, 0, center * 2, center * 2);
};
